import timemachine from 'timemachine'

// Used for tests
timemachine.reset()
if (window.testTimeMachineData?.timeInMs)
  timemachine.config({ timestamp: window.testTimeMachineData.timeInMs, tick: true })
